<template>
  <div class="pb-5 pt-0">
    <OrganisationList />
</div>
</template>

<script>
import hubbdata from "@/hubbdata";
import OrganisationList from "@/components/Organisations/OrganisationList";

export default {
  name: "Organisations",
  components: {
    OrganisationList,
  },
  computed: {
    organisations() {
      return hubbdata.state.organisations;
    },
    hubbdata() {
      return hubbdata.getters.translations;
    },
  },
  methods: {
    linkSet(url) {
      if (url.indexOf("http") > -1){
        return true
      } else {
        return false
      }
    },
  },
  mounted: function() {
    if (this.organisations !== undefined) {
      ga('set', 'title', "Organisations"); // eslint-disable-line
      ga('send', 'pageview', location.href); // eslint-disable-line

      hubbdata.dispatch("initDB");
    }
  },
}
</script>
